import React from 'react'
import fbIcon from './images/fb-icon.png'
import twIcon from './images/twitter-icon.png'
import instaIcon from './images/instagram-icon.png';
import logo from './images/logo.png'
import  './footer.css';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <div className='footer'>
        <p>Follow </p>
        <Link to='/' ><img className='logo' src={logo} alt="" /></Link>
        <p>on </p>
        <a href='https://facebook.com'><img src={fbIcon} alt=''/></a>
        <a href='https://twitter.com'><img src={twIcon} alt='' /></a>
        <a href='https://instagram.com'><img src={instaIcon} alt='' /></a>
    </div>
  )
}

export default Footer